import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import './MarketingHeader.scss'

// Derive marketing site URL from current hostname: app.jimdev.coformit.dev → jimdev.coformit.dev
const getMarketingUrl = () => {
  if (import.meta.env.VITE_MARKETING_URL) return import.meta.env.VITE_MARKETING_URL
  const host = window.location.hostname
  const marketingHost = host.startsWith('app.') ? host.slice(4) : host
  return `${window.location.protocol}//${marketingHost}`
}
const MARKETING_URL = getMarketingUrl()

const MarketingHeader = () => {
  const { t } = useTranslation('common')
  const [menuOpen, setMenuOpen] = useState(false)

  const closeMenu = () => setMenuOpen(false)

  // Close the slide-down menu on Escape or when the viewport grows back to the
  // desktop layout (>=1024px, matching the CSS breakpoint that shows it inline).
  useEffect(() => {
    if (!menuOpen) return
    const handleResize = () => {
      if (window.innerWidth >= 1024) setMenuOpen(false)
    }
    const handleKey = (e) => {
      if (e.key === 'Escape' || e.key === 'Esc') setMenuOpen(false)
    }
    window.addEventListener('resize', handleResize)
    document.addEventListener('keydown', handleKey)
    return () => {
      window.removeEventListener('resize', handleResize)
      document.removeEventListener('keydown', handleKey)
    }
  }, [menuOpen])

  return (
    <header className="marketing-header">
      <div className="marketing-header__container">
        <a href={MARKETING_URL} className="marketing-header__logo" aria-label="CoFormIt Home">
          <img src="/logo-icon.svg" alt="" className="marketing-header__logo-img" />
          <span className="marketing-header__logo-text">
            <span className="marketing-header__logo-co">Co</span>FormIt
          </span>
        </a>

        <nav className="marketing-header__nav">
          <div
            id="marketing-menu"
            className={`marketing-header__menu ${menuOpen ? 'marketing-header__menu--open' : ''}`}
          >
            <ul className="marketing-header__links">
              <li><a href={`${MARKETING_URL}/features.html`} onClick={closeMenu}>{t('marketingNav.features')}</a></li>
              <li><a href={`${MARKETING_URL}/pricing.html`} onClick={closeMenu}>{t('marketingNav.pricing')}</a></li>
              <li><a href={`${MARKETING_URL}/about.html`} onClick={closeMenu}>{t('marketingNav.about')}</a></li>
              <li><a href={`${MARKETING_URL}/contact.html`} onClick={closeMenu}>{t('marketingNav.contact')}</a></li>
              <li><Link to="/help" onClick={closeMenu}>{t('marketingNav.help')}</Link></li>
            </ul>
            <div className="marketing-header__cta">
              <Link to="/login" className="marketing-header__btn marketing-header__btn--sign-in" onClick={closeMenu}>
                {t('marketingNav.signIn')}
              </Link>
              <Link to="/sign-up" className="marketing-header__btn marketing-header__btn--trial" onClick={closeMenu}>
                {t('marketingNav.startFreeTrial')}
              </Link>
            </div>
          </div>

          <button
            type="button"
            className="marketing-header__toggle"
            aria-expanded={menuOpen}
            aria-controls="marketing-menu"
            aria-label={t('marketingNav.toggleMenu')}
            onClick={() => setMenuOpen((open) => !open)}
          >
            {menuOpen ? '✕' : '☰'}
          </button>
        </nav>
      </div>
    </header>
  )
}

export default MarketingHeader
